import { createFileRoute } from '@tanstack/react-router';
import { TenantContext } from '@interxfi/api-client';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table';
import { UserauthTenantsTable } from '../../../../../../features/userauth/tenant/userauth-tenants-table';
import type { RouteGuardOptions } from '../../../../../../util/routing/guard';
import { getPageHead } from '../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_platform/_context-required/tenant/_tenant/')({
  staticData: {
    guard: { access: { allowedTenantTypes: [TenantContext.Platform] } },
  } as const satisfies RouteGuardOptions,
  shouldReload: true,
  head: () => getPageHead('Tenants'),
  component: TenantsList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  return (
    <HorizontalStack align="end" blockAlign="center" gap={2} wrap="nowrap">
      {filter}
    </HorizontalStack>
  );
}

function TenantsList() {
  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <UserauthTenantsTable HeaderActions={TableHeader} />
      </PageLayout.Section>
    </PageLayout>
  );
}
